import { renderMarketingPage, SUPPORT_EMAIL } from './shared.js';

export function renderRefund(container, signedIn) {
  const body = `
    <main class="mkt-main">
      <section class="mkt-page-hero mkt-page-hero-legal">
        <h1>Refund &amp; Cancellation Policy</h1>
        <p>Last updated: 15 July 2026</p>
      </section>

      <section class="mkt-section mkt-prose">
        <p>
          This policy explains how cancellations and refunds work for Simustage wallet
          recharges and the monthly viewing charge, billed in INR through our payment
          processor, Razorpay.
        </p>

        <h2>1. How billing works here</h2>
        <p>
          There are two separate charges: wallet top-ups (which you spend, at your own pace, on
          content generation and Library purchases) and the ₹100/month viewing charge (for
          viewing your own content, purchases, and free listings), auto-debited from your wallet
          balance every 30 days after your first free month. There is no separate recurring
          subscription outside the wallet — stopping top-ups is enough to stop the viewing charge
          from renewing once your balance runs out.
        </p>

        <h2>2. Refunds</h2>
        <p>
          Wallet recharges and the monthly viewing charge are generally non-refundable once
          processed, except as described below or where required by applicable law.
        </p>
        <ul>
          <li>
            <strong>Duplicate or incorrect charge:</strong> if you were charged twice, or
            charged an incorrect amount due to a technical error, contact us within 7 days of
            the charge and we will issue a full refund of the erroneous amount.
          </li>
          <li>
            <strong>Unauthorized transaction:</strong> if you believe a charge was made without
            your authorization, contact us immediately at
            <a href="mailto:${SUPPORT_EMAIL}">${SUPPORT_EMAIL}</a> and we will investigate and
            refund confirmed unauthorized charges.
          </li>
          <li>
            <strong>Service unavailability:</strong> if the Service is materially unavailable
            for an extended period due to an issue on our end, we may offer a prorated refund or
            service credit at our discretion.
          </li>
        </ul>

        <h2>3. How to request a refund</h2>
        <p>
          Email <a href="mailto:${SUPPORT_EMAIL}">${SUPPORT_EMAIL}</a> with your account email
          and the reason for your request. We aim to respond within 3–5 business days. Approved
          refunds are issued to the original payment method via Razorpay and may take 5–7
          business days to appear, depending on your bank.
        </p>

        <h2>4. Free first month</h2>
        <p>
          Every new account gets 30 free days before the viewing charge ever applies — nothing
          is charged during this period, so no refund applies to it. You can stop using
          Simustage or delete your account at any time from Settings.
        </p>

        <h2>5. Changes to this policy</h2>
        <p>
          We may update this Refund &amp; Cancellation Policy from time to time; the current
          version always applies. We will post updates here with a new "last updated" date.
        </p>

        <h2>6. Contact</h2>
        <p>
          For billing help, write to <a href="mailto:${SUPPORT_EMAIL}">${SUPPORT_EMAIL}</a>.
        </p>
      </section>
    </main>
  `;
  renderMarketingPage(container, '/refund', signedIn, body);
}
